import { BooleanInput, minLength, required, TextInput } from 'react-admin';
import { SimpleForm } from '@components/SimpleForm';

export const RoleForm = () => {
    return (
        <SimpleForm>
            <TextInput source="name" validate={[required(), minLength(2)]} />
            <BooleanInput source="isActive" defaultValue={true} />
        </SimpleForm>
    );
};
